<template>
	<v-dialog v-model="dialog" persistent max-width="480">
		<v-card>
			<v-card-title class="d-flex justify-space-between align-center confirm-header">
				<span class="text-h6 confirm-header-text">{{ title }}</span>
				<v-btn icon variant="text" class="confirm-header-icon" @click="cancel">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pt-4 text-body-1">
				<div v-if="sessionLabel" class="session-origine mb-3">
					Session d’origine :
					<strong>{{ sessionLabel }}</strong>
				</div>
				{{ message }}
			</v-card-text>
			<v-card-actions class="justify-end ga-2 pa-3">
				<v-btn size="small" variant="outlined" @click="cancel">Annuler</v-btn>
				<v-btn size="small" class="confirm-btn" @click="confirm">Confirmer</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineProps({
	title: {
		type: String,
		default: 'Confirmation',
	},
	message: {
		type: String,
		required: true,
	},
	sessionLabel: {
		type: String,
		default: '',
	},
})

const emit = defineEmits(['confirm', 'cancel'])

const dialog = ref(true)

function confirm() {
	dialog.value = false
	emit('confirm')
}

function cancel() {
	dialog.value = false
	emit('cancel')
}
</script>

<style scoped>
.confirm-header {
	background-color: #417985 !important;
	color: #fff !important;
	border-radius: 3px 3px 0 0;
}
.confirm-header-text {
	color: #fff !important;
}
.confirm-header-icon .v-icon {
	color: #fff !important;
}
.confirm-btn {
	background: linear-gradient(45deg, #008080, #004455) !important;
	color: #fff !important;
	text-transform: none;
	font-weight: bold;
}
.session-origine {
	font-size: 0.95rem;
	line-height: 1.4;
	padding: 8px 10px;
	border-radius: 4px;
	background: #f3f7f8;
	border: 1px solid #d7e4e7;
}
</style>
